<template>
  <span v-show="!!selectedEntity">{{ selectedEntity?.text }}</span>
</template>

<script setup>
import { computed, onMounted, ref, toRef } from "vue"
import { useAuth } from "../composition-api/useAuth"
import { EntityState } from "./EntityState"

defineOptions({ name: "DisplayEntity" })

const props = defineProps({
  apiEntity: String,
  filter: String,
  modelValue: String,
})

const { fetchAuthAsync } = useAuth()

const entities = ref([])
const filter = toRef(props, "filter")

const loadAsync = async () => {
  entities.value = await EntityState.getEntitiesAsync(fetchAuthAsync, props.apiEntity, filter.value)
}

const selectedEntity = computed(() => entities.value.find((e) => e.id === props.modelValue))

onMounted(async () => loadAsync())
</script>
